'use client';

import { getConsentSnapshot, readConsentCookieFromDocument } from '@/lib/cookie-consent/consent';

export type PublicToolAction = {
  tool: string;
  action: 'copy' | 'download';
  format: 'txt' | 'docx' | 'pdf' | 'csv' | 'json';
  variant?: 'blank' | 'example';
};

function hasConsent() {
  return getConsentSnapshot(readConsentCookieFromDocument()).consent?.analytics === true;
}

/** Fixed resource identifiers only. Never pass calculator values, URLs or document contents. */
export async function trackPublicToolAction({
  tool,
  action,
  format,
  variant,
}: PublicToolAction): Promise<void> {
  if (typeof document === 'undefined' || !/^[a-z0-9-]{1,80}$/.test(tool)) return;
  try {
    if (!hasConsent()) return;
    const { capturePostHogEvent } = await import('@/lib/telemetry/client-runtime');
    if (!hasConsent()) return;
    await capturePostHogEvent('public_tool_output_used', { tool, action, format, variant });
  } catch {
    // Saving an output must still work when analytics is unavailable.
  }
}
